import { isAnnualTimePeriod, isMonthlyTimePeriod } from '../pricing-period';
import type { BillingPlan } from '../types';

function hasFormattedPrice(value?: string | null): boolean {
  return value != null && value !== '';
}

export function planHasMonthlyCouponPrice(plan: BillingPlan): boolean {
  return hasFormattedPrice(plan.formatted_coupon_monthly_price);
}

export function planHasAnnualCouponPrice(plan: BillingPlan): boolean {
  return hasFormattedPrice(plan.formatted_coupon_annual_price_per_month);
}

export function shouldShowPromotionalMonthlyRate(
  timePeriod: string,
  isHelloSign: boolean,
  plan: BillingPlan,
  hasValidCoupon: boolean,
): boolean {
  return (
    isMonthlyTimePeriod(timePeriod) &&
    !isHelloSign &&
    hasValidCoupon &&
    planHasMonthlyCouponPrice(plan)
  );
}

export function shouldShowPromotionalAnnualRate(
  timePeriod: string,
  isHelloSign: boolean,
  plan: BillingPlan,
  hasValidCoupon: boolean,
): boolean {
  return (
    isAnnualTimePeriod(timePeriod) &&
    !isHelloSign &&
    hasValidCoupon &&
    planHasAnnualCouponPrice(plan)
  );
}
